// extracted by mini-css-extract-plugin
module.exports = {"root":"Reh3UP","products":"BleM7N","seeMoreButton":"EPmlzA"};